import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import Loader from '../../Main/Loader'
import { updatePassword } from '../../../Services/DashboardServices'
import toast from 'react-hot-toast'
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa'

const UpdatePassword = () => {

    const [password, setPassword] = useState("")
    const [oldPassword, setOldPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false)


    const handlePassword = (e) => { setPassword(e.target.value) }
    const handleConfirmPassword = (e) => { setConfirmPassword(e.target.value) }
    const handleOldPassword = (e) => { setOldPassword(e.target.value) }

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        let body = {
            old_password: oldPassword,
            password: password,
            password_confirmation: confirmPassword
        }
        setIsLoading(true)
        let response = await updatePassword(body)
        if (response.code === 201) {
            toast?.success(response?.message)

            setIsLoading(false)
            setPassword("")
            setOldPassword("")
            setConfirmPassword("")

        } else if (response.code === 400) {
            toast?.error(response?.message)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    return (
        <>
            <div className="card border-0 shadow p-3 mt-3">

                <h3 className='fw-bold'>Update Password</h3>

                <Form onSubmit={handleSubmit}>

                    {/* Old Password */}
                    <Form.Group className="mb-3 position-relative" controlId="formOldPassword">
                        <Form.Label>Old Password</Form.Label>
                        <Form.Control
                            onChange={handleOldPassword}
                            value={oldPassword}
                            type={showOld ? 'text' : 'password'}
                            placeholder="Old Password"
                        />
                        <span
                            onClick={() => setShowOld(!showOld)}
                            style={{
                                position: 'absolute',
                                top: '38px',
                                right: '15px',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            {showOld ? <FaRegEyeSlash /> : <FaRegEye />}
                        </span>
                    </Form.Group>

                    {/* New Password */}
                    <Form.Group className="mb-3 position-relative" controlId="formNewPassword">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            onChange={handlePassword}
                            value={password}
                            type={showNew ? 'text' : 'password'}
                            placeholder="New Password"
                        />
                        <span
                            onClick={() => setShowNew(!showNew)}
                            style={{
                                position: 'absolute',
                                top: '38px',
                                right: '15px',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            {showNew ? <FaRegEyeSlash /> : <FaRegEye />}
                        </span>
                    </Form.Group>

                    {/* Confirm Password */}
                    <Form.Group className="mb-3 position-relative" controlId="formConfirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            onChange={handleConfirmPassword}
                            value={confirmPassword}
                            type={showConfirm ? 'text' : 'password'}
                            placeholder="Confirm Password"
                        />
                        <span
                            onClick={() => setShowConfirm(!showConfirm)}
                            style={{
                                position: 'absolute',
                                top: '38px',
                                right: '15px',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            {showConfirm ? <FaRegEyeSlash /> : <FaRegEye />}
                        </span>
                    </Form.Group>

                    <Button variant="primary" className='w-100' type="submit">
                        {isLoading ? <Loader /> : "Update"}
                    </Button>
                </Form>
            </div>
        </>
    )
}

export default UpdatePassword